module.exports = __webpack_public_path__ + "static/img/3.e27992f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/flag_icons/3.png
// module id = rFq2
// module chunks = 1